import axios from 'axios';
import { PersonFace } from './personFace.types';

// Утилита для преобразования Base64 строки в Uint8Array для браузера
const base64ToUint8Array = (base64: string): Uint8Array => {
  const binaryString = atob(base64); // Декодируем Base64 в бинарную строку
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

const API_URL = '/pcnt/face_referer_data';

export const uint8ArrayToBase64 = (array: Uint8Array): string => {
  const binaryString = String.fromCharCode(...array);
  return btoa(binaryString);
}

export const uint8ArrayToBlob = (array: Uint8Array): string => {
  const blob = new Blob([array as BlobPart], { type: 'image/png' });
  return URL.createObjectURL(blob);
};

export const api = {
  get: async (personId: number): Promise<PersonFace[]> => {
    const res = await axios.get<PersonFace[]>(`${API_URL}/person/${personId}`, { // API_URL_FACES
      });
    // console.log('res.data:', JSON.stringify(res.data[43])); // base64 проверка
    return res.data
      // .filter((face:any) => face.person === personId) // todo: преобразоввать наименования
      .map((face:any) => ({
        ...face,
        faceUuid: face.face_uuid, // todo: преобразоввать наименования
        personId: face.person_id,
        photo: base64ToUint8Array(face.photo),
      })) as PersonFace[];
   },

  add: async (data: PersonFace): Promise<PersonFace> => {
    const dataToInsert = {
      face_uuid: data.faceUuid,
      person_id: data.personId,
      photo: uint8ArrayToBase64(data.photo),
      comment: data.comment,
    };
    await axios.post(`${API_URL}/`, dataToInsert, {
    });
    return data;
  },

  deleteFaces: async (faceUuids: string[]): Promise<void> => {
    for (const uuid of faceUuids) {
      await axios.delete(`${API_URL}/${uuid}/`, {
      });
    }
  },

  patchSortord: async (faceUuid: string, sortord: number): Promise<void> => {
    await axios.patch(`${API_URL}/${faceUuid}/`, {sortord});
  },

  updateFacesOrder: (faces: PersonFace[]) => {
    return Promise.all(
      faces.map(face => api.patchSortord(face.faceUuid, face.sortord ?? 0))
    );
  },
}